import {inject, Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TitleStrategy, RouterStateSnapshot} from '@angular/router';
import { TranslateService ,_} from '@ngx-translate/core';
import {Subscription} from "rxjs";

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);
    private subscription?: Subscription;
    private translate = inject(TranslateService);

    updateTitle(snapshot: RouterStateSnapshot): void {
        // PageTitle is equal to the "Title" of a route if it's set
        // If  not set it will use the "title" given in index.html
        const pageTitle = this.buildTitle(snapshot) || this.title.getTitle();
        //console.log("Title Strategy: ",pageTitle);
        this.translate.get(_(pageTitle))
            .subscribe((text: string) =>
            {
                this.title.setTitle(`${text}`);
                //console.log("Title Strategy: ",text);
            });
    }
}